import { connect } from 'react-redux';
import { IDataStorage } from '../../../core';
import { FxTranslate } from '../../../core/translate';
import { ICardEdit } from '../../../services/operaciones/model/ICardEdit';
import { Secciones } from '../index.service';
import styles from './index.module.scss';
import { Forms, Loader } from '../..';
import { MonedaComboItem } from '../../../model/cobranza/MonedaComboItem';

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;
  
  monedas?: MonedaComboItem[] | null | undefined;

  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

function CardSeccionConciliacion({ storage, t,
  data,
  monedas,
  onUpdateFields,
} : IProps) {
  const onUpdateField = (field: string, value: any) => onUpdateFields([ { field, value }]);

  return <div className={styles["card-seccion-content"]}>
    <div className={styles["card-seccion-title"]}>{t(`Menu.${Secciones.Conciliacion}`)}</div>
        
    <div className='p-grid'>
      
    <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Input 
          title={t("Seccion.Field.operacionfacturacion.conciliadoFacturaNumero")}
          className={styles["fix-form-component"]}
          value={data?.operacionfacturacion?.conciliadofacturanumero}
          onChange={(v,e) => onUpdateField('operacionfacturacion.conciliadoFacturaNumero', v)}
        />
      </div>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Calendar 
          title={t("Seccion.Field.operacionfacturacion.conciliadoFacturaFecha")}
          className={styles["fix-form-component"]}
          value={data?.operacionfacturacion?.conciliadofacturafecha ? new Date(data?.operacionfacturacion?.conciliadofacturafecha) : undefined}
          onChange={(v,e) => onUpdateField('operacionfacturacion.conciliadoFacturaFecha', v)}
        />
      </div>
      <div className='p-col-12 p-lg-12 p-p-2'>
        <Forms.UploadSingleFile 
          title={t("Seccion.Field.operacionfacturacion.conciliadoFacturaArchivo")}
          className={styles["fix-form-component"]}
          hideDelete
          value={data?.operacionfacturacion?.conciliadoFacturaArchivoDTO}
          onChange={(v,e) => onUpdateField('operacionfacturacion.conciliadoFacturaArchivoDTO', v)}
        />
      </div>

      <div className='p-col-12 p-lg-6 p-p-2'>
        <Forms.Calendar 
          title={t("Seccion.Field.operacionfacturacion.conciliadoFecha")}
          className={styles["fix-form-component"]}
          value={data?.operacionfacturacion?.conciliadofecha ? new Date(data?.operacionfacturacion?.conciliadofecha) : undefined}
          onChange={(v,e) => onUpdateField('operacionfacturacion.conciliadoFecha', v)}
        />
      </div>
      <div className='p-col-12 p-lg-6 p-p-2'>
        <Loader loading={!monedas}>
          <Forms.Dropdown
            title={t("Seccion.Field.operacionfacturacion.conciliadoMoneda")}
            className={styles["fix-form-component"]}
            value={data?.operacionfacturacion?.conciliadomoneda}
            options={() => (monedas ?? []).map(p => ({ id: p.id, nombre: `${p.showKey} (${p.codigo ?? ' '})` }))} optionLabel="nombre" optionValue="id"
            onChange={(v,e) => {
              if (!data?.operacionfacturacion) data!.operacionfacturacion = {} as any;
              data!.operacionfacturacion!.conciliadomoneda = v;
              onUpdateField('operacionfacturacion.conciliadoMoneda', v)
            }}
          />
        </Loader>
      </div>
      <div className='p-col-12 p-lg-12 p-p-2'>
        <Forms.InputNumber
          title={t("Seccion.Field.operacionfacturacion.conciliadoCostoPrima")}
          className={styles["fix-form-component"]}
          value={data?.operacionfacturacion?.conciliadocostoprima}
          onChange={(v,e) => onUpdateField('operacionfacturacion.conciliadoCostoPrima', v)}
        />
      </div>
    </div>
  </div>;
}
export default connect((s:any) => ({ storage:s.main }))(CardSeccionConciliacion);
